import { Component, ElementRef, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { parseDate } from '@progress/kendo-angular-intl';
import { isEmpty, Observable } from 'rxjs';
import { ComponentBase } from '~/infrastructure/component-base';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountListing, AccountSummary } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { SiteLisitng } from '~/models/administration/site';
import { EntityStatusOptions } from '~/models/entityStatus';
import { loginSourceOptions } from '~/models/loginSource';
import { IAssetDto, IAssetListing } from '~/models/modules/Asset/asset';
import { IAssetModelDto} from '~/models/modules/Asset/assetModel';
import { IAssetTransferRequestDetailsDto } from '~/models/modules/Asset/Transactions/Transfer/assetTransferDetailsDto';
import { IAssetTransferRequestDto, IAssetTransferRequestExtandDto } from '~/models/modules/Asset/Transactions/Transfer/assetTransferDto';
import { systemTransactionsList } from '~/models/modules/Common/systemTransactionList';
import { ISystemTransactionsFields } from '~/models/modules/Common/systemTransactionsFieldsDto';
import { FileSelectedStream } from '~/models/modules/file';
import { GridFieldSummary } from '~/models/modules/gridField';
import { Sites } from '~/models/Site';
import { SitesListComponent } from '~/modules/stocks/files/sites/list/list.component';
import { AccountsService } from '~/services/administration.ts/accounts';
import { FormatService } from '~/services/administration.ts/format';
import { AssetService } from '~/services/modules/assets/asset.service';
import { AssetModelService } from '~/services/modules/assets/asset-model.service';
import { AssetTransferTransactionsService } from '~/services/modules/assets/transactions/transferTransaction';
import { SystemTransactionsFieldsService } from '~/services/modules/common/system-transactions-fields.service';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { GridLayoutComponent } from '~/shared/components/grid/layout/layout.component';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { fileSources } from '~/shared/enums/fileSources';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { PageState } from '~/shared/enums/stock-files.enum';
import {SettingsService} from '~/services/modules/assets/settings/Setting';

@Component({
    selector: 'app-asset-transfer-upsert',
    templateUrl: './asset-transfer-upsert.component.html',
    styleUrls: ['./asset-transfer-upsert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssetTransferUpsertComponent extends ComponentBase implements OnInit {
  _entity = 'asset';
  _theme: string;
  _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _fromAccounts: AccountListing[];
  _fromAccountsDD:FormControl = new FormControl();
  _toAccounts: AccountListing[];
  _toAccountsDD:FormControl = new FormControl();
  _fromSites: SiteLisitng[];
  _toSites: SiteLisitng[];
  _model:IAssetTransferRequestDto;
  _isProcessed: boolean = false;
  _selectedFromAccounts:AccountListing;
  _selectedFromSites:SiteLisitng;
  _selectedToAccounts:AccountListing;
  _selectedToSites:SiteLisitng;
  _scheduledDate:string;
  _pageName:string = 'asset-transfer-transaction';
  _pageState: PageState;
  costPriceFormatType: FormatTypes= FormatTypes.CostandPriceFormat;
  _invalidForm:boolean = false;

  /////// Assets Data Listing //////
  assetsData: IAssetDto[] = [];
  assetsDataFiltered: IAssetDto[] = [];
  modelsData: IAssetModelDto[] = [];
  modelsDataFiltered: IAssetModelDto[] = [];
  _assetsAuth:GridFieldAuthorization;
  _assetsGridFields:GridFieldSummary[] = [];
  _assetsPageName:string = 'assets'
  _assetsListEnabled:boolean = false;
  _selectedAssets:number[] = [];
  _assetsCode = new FormControl();
  _assetsDD = new FormControl();

  _assetComboBoxPagingParams = {
    currentItem: '0',
    totalbyPage: 20,
    search:'',
    page: 1
  };
  _modelComboBoxPagingParams = {
    currentItem: '0',
    totalbyPage: 20,
    search:'',
    page: 1
  };
  _assetComboScroll:boolean = false;
  _modelComboScroll:boolean = false;
  _assetDDSearch:string = null;
  _modelDDSearch:string = null;
  _assetDDSize:number = 20;

  public virtual: any = {
    itemHeight: 28,
    pageSize:20
  };
  isOpened:boolean = false;
  clearTimeout: any;
  _allAssetCount:number = 0;
  _allModelsCount:number = 0;


  public get selectedItems(): FormArray {
    return <FormArray>this._form.get('selectedItems');
  }
  _gridSelectedAssets:number[] = [];
  _assetDataArray:IAssetDto[] = [];
  _modelDataArray:IAssetModelDto[] = [];
  _transactionFields:ISystemTransactionsFields[] = [];
  _assetsTransactionGridFields:GridFieldSummary[] = [];
  _assetsEditableTransactionGridFields:GridFieldSummary[] = [];
  _sortingSelected = new FormControl('old');

  // #region Attach Document
  _uploadedStream: FileSelectedStream[]= [];
  _selectedExistingFiles: FileSelectedStream[]= [];
  _fileSource: fileSources;
  _uploaderSelectMessage:string = 'Upload file..';
  _showDocumentsGrid:boolean = false;
  _selectedDocumentsKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _selectedObjectDocuments: any[] = [];
  _allowedFileTypes : allowedFileTypes[] = [allowedFileTypes.excel, allowedFileTypes.pdf, allowedFileTypes.word];
  _file: File;
  _fileStream: any;
  _selectFile: boolean = false;
  _selectedInventoryKeys:number[] = [];
  _assettransfergMode:boolean;
  _assetTransfergSetting:string;
  // #endregion

  @ViewChild('SelectedItemsGrid') SelectedItemsGrid:GridLayoutComponent<any>;
  @ViewChild('NewToOldSort') newToOldSort:ElementRef;
  constructor(
    private _layoutManager: LayoutManagerService,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _assetService: AssetService,
    private _modelService: AssetModelService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _gridFields: GridFieldsService,
    private _transferRequestsService: AssetTransferTransactionsService,
    private _systemTransactionFieldsService: SystemTransactionsFieldsService,
    private _fb: FormBuilder,
    private _formatService : FormatService,
    private _layoutComponent: LayoutComponent,
    private _filesService: FilesService,
    private _sharedService: SharedService,
    private _renderer2:Renderer2,
    private _settingService : SettingsService) { super(); }

  ngOnInit(): void {
    this._sortingSelected.valueChanges.subscribe((x) => {
      let TempAssetDataArray = [...this._assetDataArray];
      TempAssetDataArray.reverse();
      this._assetDataArray = [...TempAssetDataArray];
    });
    this.getTransactionFields();
    this._isNew = true;
    this._pageState = PageState.ADD;
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this.initForm();
    this.loadAccountsData();
    this._getData();
    //this._active = true;
    if(Object.keys(this._model).length > 0){
      this._pageState = PageState.EDIT;
    this.getAssetsDD();
    this.getModelsDD();
    }
  }
  _getData(){
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    if(Object.keys(this._model).length > 0){
      this.loadFromSitesData(this._model.accountFromId);
      this.loadToSitesData(this._model.accountToId);
      this._model.assetTransferRequestDetails.forEach((f:IAssetTransferRequestDetailsDto) => {
        this.addSelectedItem(f.asset,f.id);
      });
    }
    this.setSelectedType();
    this.initForm();
    //this.newToOldSort.nativeElement.click();
  }

  private setSelectedType(){
    this._settingService.GetSettingByName('transferAssetType')
    
    .subscribe((response:any) =>{
      if(response != null ){
        this._assettransfergMode = response.value.toLowerCase() == "asset" ? true : false;
        this._assetTransfergSetting = response.value.toLowerCase();
    }
    })

  }


  initForm(){
    this._form = this._fb.group({
      assetNumber:[null],
      modelNumber:[null],
      fromAccount:[this._model?.accountFrom, Validators.required],
      toAccount:[this._model?.accountTo, Validators.required],
      fromSite:[this._model?.siteFrom, Validators.required],
      toSite:[this._model?.siteTo, Validators.required],
      notes:[(this._model && this._model.notes) ? this._model.notes : null],
      scheduleDate: [(this._model && this._model.scheduleDate) ? parseDate(this._model.scheduleDate) : null],
      selectedItems:this._fb.array([])
    });
  }
  loadAccountsData(){
    this._accountsService.getAccountsListing()
    
    .subscribe((data: AccountListing[]) => {
      this._fromAccounts = [...data];
      this._toAccounts = [...data];
    });
  }
  _fromAccountsSelectionChanged(model:AccountListing){
    this._selectedFromAccounts = model;
    this._selectedToAccounts = null;
    this._fromSites = [];
    this._selectedFromSites = null;
    this._toSites = [];
    this._selectedToSites = null;
    setTimeout(() => {
      this._fromAccountsDD.setValue(model);
      this._form.patchValue({
        fromAccount:model
      })
      this.loadFromSitesData(model.id);
    }, 500);
  }
  loadFromSitesData(accountId:number){
    this._accountsService.getSitesListByAccount(accountId)
    
    .subscribe((data: SiteLisitng[]) => {
      this._fromSites = [...data];
    });
  }
  _fromSitesSelectionChanged(siteId:SiteLisitng){
    this._selectedFromSites = siteId;
  }
  _toAccountsSelectionChanged(model:AccountListing){
    this._selectedToAccounts = model;
    setTimeout(() => {
      this._toAccountsDD.setValue(model);
      this._form.patchValue({
        toAccount:model
      })
      this.loadToSitesData(model.id);
    }, 500);
  }
  loadToSitesData(accountId:number){
    this._accountsService.getSitesListByAccount(accountId)
    
    .subscribe((data: SiteLisitng[]) => {
      this._toSites = [...data];
    });
  }
  _toSitesSelectionChanged(siteId:SiteLisitng){
    this._selectedToSites = siteId;
    if(this._assettransfergMode){
    this.getAssetsDD();
    }
    else{
    this.getModelsDD();
    }
  }
  _modelSelectionChanged(selectedModel:IAssetModelDto){
    if(selectedModel == undefined){
      this._assetDataArray = [];
      return;
    }
    this.getModelAssets(selectedModel.id);
    // this._selectedToSites = siteId;
    // if(this._assettransfergMode){
    // this.getAssetsDD();
    // }
    // else{
    // this.getModelsDD();
    // }
  }
  _onScheduleDateChange(value:Date){
    this._scheduledDate = value.toLocaleDateString();
  }
  _onSave(e: any) {
    var saveModel:IAssetTransferRequestExtandDto = this.generateRequestModel();
    
    if(this._form.value.fromSite == undefined || this._form.value.toSite == undefined){
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please Select the (from) and (to) sites',
          returnAfterOkCloseClick: true,
          withoutConfirm: true
      });
      return;
    }
    else if(this._form.value.fromSite.id === this._form.value.toSite.id){
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Cannot Transfer To The Same Site!',
        returnAfterOkCloseClick: true,
        withoutConfirm: true
    });
    return;
    }
    if(this._assetDataArray === undefined || this._assetDataArray.length == 0 || saveModel.assetTransferRequestDetails.length == 0){
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please Select Items To Transfer',
          returnAfterOkCloseClick: true,
          withoutConfirm: true
      });
      return;
    }
    if (this._form.invalid) {
      this._invalidForm = true;
    } else {
        this._invalidForm = false;
    }
    if(this._invalidForm == false){
      //this._pacer.start(true);
          if ( this._uploadedStream.length > 0 || this._selectedExistingFiles.length > 0){
            this._saveTransactionFiles();
          }
          else {
              this.addTransferRequest(null);
          }
    }
  }
  private addTransferRequest(fileIds?: number[]){
    var saveModel:IAssetTransferRequestExtandDto = this.generateRequestModel();
    if(fileIds){
      saveModel.assetTransferRequestFiles = fileIds.map((v:number) => {
        return {
          fileid:v,
          assetTransferRequestId:this._model?.id ?? 0,
          file:null as any,
          id:0,
          status: EntityStatusOptions.Active,
          assetTransferRequest:this._model,
          comment:'',
          createdById:'',
          createdOn:null as any,
          lastUpdatedById:'',
          lastUpdatedOn:null as any
        }
      });
      }
      else{
        saveModel.assetTransferRequestFiles = [];
      }
      this.doAddTransferRequest(saveModel);
  }
  private doAddTransferRequest(saveModel:IAssetTransferRequestDto){
    if(this._pageState == PageState.ADD){
      this._transferRequestsService.createTransferTransaction(saveModel)
      
      .subscribe((response: any) =>{
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          this._closeForm();
        }
      });
    }
    else if(this._pageState == PageState.EDIT){
      this._transferRequestsService.updateTransferTransaction(this._model.id, saveModel)
      
      .subscribe((response: any) =>{
        if (response != null && response['message'] != null) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response['message'],
            withoutConfirm: true
          });
          this._closeForm();
        }
      });
    }
  }
  generateRequestModel():IAssetTransferRequestExtandDto{
    const retModel:IAssetTransferRequestExtandDto = <IAssetTransferRequestExtandDto>({
      lastUpdatedOn:new Date(),
      id: this._model?.id ?? 0,
      accountFrom: this._form.controls.fromAccount.value,
      accountFromId: this._form.controls.fromAccount.value?.id,
      siteFrom: this._form.controls.fromSite.value,
      siteFromId: this._form.controls.fromSite.value?.id,
      accountTo: this._form.controls.toAccount.value,
      accountToId: this._form.controls.toAccount.value?.id,
      siteTo: this._form.controls.toSite.value,
      siteToId: this._form.controls.toSite.value?.id,
      assetTransferRequestDetails: this._assetDataArray.map((f: IAssetDto) => {
        return {
          assetTransferRequestId: this._model?.id ?? 0,
          id: Number(f.rowId ?? 0) ?? 0,
          assetId: f.id,
          asset: f,
          assetTransferRequest: this._model,
          assetStatusId: f.assetStatusId,
          assetStatus: f.assetStatus,
          conditionId: f.conditionId,
          condition: f.condition,
          model: f.model,
          modelId: f.modelId
        }
      }),
      assetTransferRequestFiles: [],
      comment: '',
      notes: this._form.controls.notes.value,
      transferStatus: 'Approved',
      processedIn: false,
      processedOut: false,
      scheduleDate: this._form.controls.scheduleDate.value,
      scheduleStatus: false,
      modelId : this._form.controls.modelNumber.value?.id,
      isModelTransaction: this._form.controls.modelNumber.value ? true : false
    });
    return retModel;
  }
  async _saveTransactionFiles(){
    let newFiles = [...this._uploadedStream];
    let existingFiles = [...this._selectedExistingFiles];

    if((newFiles != undefined && newFiles.length > 0) || (existingFiles != undefined && existingFiles.length > 0)){
      let _filesModel :any[] = [];
      newFiles.forEach(n => {
        let model: any = {};
        model.stream = n.stream;
        model.size = n.size;
        model.type = n.type;
        model.name = n.name ? n.name.substring(0, n.name.lastIndexOf('.')) : '';
        model.exension = n.name.substring(n.name.lastIndexOf(".") + 1).toLowerCase();
        model.typesToChecks = this._allowedFileTypes;
        model.existingFileId = n.existingFileId;
        model.fileSourceId = fileSources.assetTransferRequest;
        _filesModel.push(model);
      });

      await this._filesService
      .createFileRange(_filesModel)
      
      .toPromise()
      .then((response: number[]) => {
          if (response != null) {

            //let existingIds:number[] = [];
            existingFiles.forEach((v) =>{
              let ext = response.find(r => r == v.existingFileId);
              if(ext == undefined){
                response.push(v.existingFileId);
              }
            });

            this.addTransferRequest(response)
          }
      });
    }
  }
  _onStateChanges(e: any) {
    if (e === 'minimized') {
        this._layoutManager.removeOverlay();
    } else {
        this._layoutManager.applyOverly();
    }
  }
    _onCancel() {
      this._closeForm();
  }

  _closeForm() {
      var closeComponent = {
        component : this._pageName,
        isClosed : true
      }
      this._active = false;
      this._gridLayoutManagerService.setGridDataSubjects(this._pageName);
      //this.ngOnDestroy();
      this._layoutManager.removeOverlay();
      this._sharedService.closeDialog.emit(closeComponent);
      this._sharedService.model = {};
  }
  // #region Asset Data Listing
  getAssetsDD(){
    var fromSiteId = this._model.siteFromId ?? this._form.controls.fromSite.value?.id;
    var toSiteId = this._model.siteToId ?? this._form.controls.toSite.value?.id;
    // var response = this._assetService.getAssetList(this._assetComboBoxPagingParams);
    // var data:any = await firstValueFrom(response);
    if(!this._assetComboScroll) {
      var searchAsset = this._assetService.getTransferCommonList(this._assetComboBoxPagingParams, fromSiteId, toSiteId)
      
      .subscribe((data: any) => {
        this._allAssetCount = data.body.returnCount;
        this.assetsData = [...data.body.data];
        this.assetsDataFiltered = [...data.body.data];
      });
    }
    else {
      var searchAsset = this._assetService.getTransferCommonList(this._assetComboBoxPagingParams, fromSiteId, toSiteId)
      
      .subscribe((data: any) => {
        this.assetsData = this.assetsData.concat(data.body.data);
        this.assetsDataFiltered = [...this.assetsData];
      });
    }
  }
  getModelAssets(modelId:number){
    var assets = this._assetService.getModelAssets(modelId)
    
    .subscribe((data:any) =>{
      for(let i in data.data){
        this.addSelectedItem(data.data[i]);
      }
    });
  }
  getModelsDD(){
    var fromSiteId = this._model.siteFromId ?? this._form.controls.fromSite.value?.id;
    // var response = this._assetService.getAssetList(this._assetComboBoxPagingParams);
    // var data:any = await firstValueFrom(response);
    if(!this._modelComboScroll) {
      var searchAsset = this._modelService.getSiteModels(fromSiteId)
      
      .subscribe((data: any) => {
        this._allModelsCount = data.returnCount;
        this.modelsData = [...data.data];
        this.modelsDataFiltered = [...data.data];
      });
    }
    else {
      var searchAsset = this._modelService.getSiteModels(fromSiteId)
      // var searchAsset = this._modelService.getSiteModels(this._modelComboBoxPagingParams, fromSiteId, toSiteId)
      
      .subscribe((data: any) => {
        this.modelsData = this.modelsData.concat(data.body.data);
        this.modelsDataFiltered = [...this.modelsData];
      });
    }
  }
  _openAssetsList():void {
    if(this._assetsGridFields == undefined || this._assetsGridFields.length == 0){
      this._getAssetsGridFields();
    }
    this._assetsListEnabled = true;
  }
  _getAssetsGridFields() {
    this._gridFields
      .getGridFieldsByPage(this._assetsPageName)
      
      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._assetsPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._assetsPageName, (gridColumns) => {
      this._assetsGridFields = gridColumns;
    });
  }
  _closeAssetsList():void {
    this._assetsListEnabled = false;
  }
  _returnSelectedAssetsHandler(e:IAssetDto):void{
    this._assetService.getAssetRange(this._selectedAssets)
    
    .subscribe((data:IAssetDto[]) =>{
      data.forEach((item:IAssetDto) => {
        if(this.assetsData.find(f => f.id == item.id) == undefined){
          this.assetsData.push(item);
        }
          this._assetsDD.setValue(item);
          this._form.patchValue({
            assetNumber:item
          });
        this.addSelectedItem(item);
      });
    });
    this._closeAssetsList();
  }
  _onAssetsRowSelectionChanges(e: any[]) {
    this._selectedAssets = [...e];
  }
  _onAssetsObjectRowSelectionChanges(e: any[]) {

  }
  _getAssets = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._assetService.getAssetGrid(params,model, null, 0, 0);
  };
  /* _onOpenAssetForm():void{
    this._openForm(this._assetsPageName);
  } */
  _onCloseAddAsset(data:any){
    let newItem = data.response;
    this.assetsData.push(newItem);
      this._assetsDD.setValue(newItem);
      this._form.patchValue({
        assetNumber:newItem
      });
      this.addSelectedItem(newItem);
  }
  /* _skipAddNewAsset(){
    this._form.controls.assetNumber.setValue(null);
    this._assetDDSearch = '';
    this.kendoComboAssets.blur();
    this.setAssetFocus();
  } */
  _handleAssetsFilter(_filter:any){
      this._assetDDSearch = _filter;
      this._assetComboScroll = false;
    setTimeout(() => {
      this._assetComboBoxPagingParams.search = _filter;
      this._assetComboBoxPagingParams.currentItem = '0';
      this._assetComboBoxPagingParams.page = 1;
      this.getAssetsDD();
    }, 1000);
  }
  _handleModelsFilter(_filter:any){
    this._modelDDSearch = _filter;
    this._modelComboScroll = false;
  setTimeout(() => {
    this._modelComboBoxPagingParams.search = _filter;
    this._modelComboBoxPagingParams.currentItem = '0';
    this._modelComboBoxPagingParams.page = 1;
    this.getModelsDD();
  }, 1000);
}
  scrollCombobox(event:any){
      this.isOpened = true;
      if (this.clearTimeout) clearTimeout(this.clearTimeout);
      this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
          let domobject = document.querySelector('.k-list-content') ;
          if (domobject) {
              this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e:any) => {
                if(this.assetsData.length < this._allAssetCount){
                  if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
                    this._assetComboScroll = true;
                    this._assetComboBoxPagingParams.currentItem = (parseInt(this._assetComboBoxPagingParams.currentItem) + this._assetComboBoxPagingParams.totalbyPage).toString();
                    this._assetComboBoxPagingParams.page++;
                    this.getAssetsDD();
                  }
                }
              });
          }
        }
    }, 500);
  }
  scrollModelCombobox(event:any){
      this.isOpened = true;
      if (this.clearTimeout) clearTimeout(this.clearTimeout);
      this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
          let domobject = document.querySelector('.k-list-content') ;
          if (domobject) {
              this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e:any) => {
                if(this.modelsData.length < this._allModelsCount){
                  if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
                    this._modelComboScroll = true;
                    this._modelComboBoxPagingParams.currentItem = (parseInt(this._modelComboBoxPagingParams.currentItem) + this._modelComboBoxPagingParams.totalbyPage).toString();
                    this._modelComboBoxPagingParams.page++;
                    this.getModelsDD();
                  }
                }
              });
          }
        }
    }, 500);
  }
  /* _handleAssetValueChange(selectedData: IAssetListing){
    //this._pacer.start();
    this._form.patchValue({
      assetNotes:''
    });
    this._notesService.getNotesByPage(selectedData?.id, 'assets')
    
    .subscribe((data: NoteSummary[]) => {
      if(data != undefined) {
        if(data.length > 0){
          data.reverse();
          this._form.patchValue({
            assetNotes:data[0].description
          });
        }
      }
    });
  } */

  // #endregion

  // #region Selected Items Grid

private async getTransactionFields(){
  this._systemTransactionFieldsService.getFieldsByTransaction(systemTransactionsList.assetTransferRequests)
  
      .subscribe((data:ISystemTransactionsFields[]) => {
        this._transactionFields = <ISystemTransactionsFields[]>([...data]);

        this.setSelectedGridFields();
        /* setTimeout(() => {
          this.clearButton.nativeElement.click();
        }, 500); */
      });
  }
  setSelectedGridFields(){
    this._assetsTransactionGridFields = this._transactionFields.map(f => f.gridFieldDefinition);
          this._assetsTransactionGridFields.forEach((f:GridFieldSummary) => {
            f.selected = true;
            /* if(f.field == 'condition.conditionId' || f.field == 'assetStatus.statusId'){
              this._assetsEditableTransactionGridFields.push(f);
              this._assetsTransactionGridFields.splice(this._assetsTransactionGridFields.indexOf(f),1);
            } */
          });
  }
  buildSelectedItem(asset: IAssetDto, rowID:number = 0):FormGroup {
    return this._fb.group({
      id:asset.id,
      index: [this.selectedItems.length],
      rowId:rowID,
      assetNumber: asset.assetNumber,
      assetName:asset.assetName,
      assetStatusesCode: asset.assetStatusId,
      conditionCode:asset.conditionId,
      locationCode:asset.locationId,
      assetData:asset,
    });
  }
  addSelectedItem(asset: IAssetDto, rowID:number = 0): void {
    this.setSelectedGridFields();
    let checkAsset = this.selectedItems.controls.find(x => x.value.id === asset.id);
    if(checkAsset == undefined){
       this.selectedItems.push(this.buildSelectedItem(asset, rowID));
       //if(this._assetDataArray.length == 0){
        this._assetDataArray = this.selectedItems.value.map((f: { assetData: IAssetDto; }) => f.assetData);
      //}
      //else{
      //  this._assetDataArray.push(asset);
      //}
      this._form.controls.assetNumber.setValue(null);
      //this._form.controls.assetNotes.setValue(null);
    }

  }
  _handleAssetKeyEnter(){
    let _selectedAssetId = this._form.controls.assetNumber.value.id;
    //let _checkAsset = this.selectedItems.controls.find(x => x.value.id === _selectedAssetId);
    let _checkAsset = this._assetDataArray.find(x => x.id === _selectedAssetId);
    if(_checkAsset == undefined){
      //let asset:IAssetDto = null;
      this._assetService.getAssetById(_selectedAssetId)
        
        .subscribe((data:IAssetDto) => {
          //asset = {...data};
          this.addSelectedItem(data);
        });

    }
    else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Asset is already added to the items',
        withoutConfirm: true
      });
    }
  }
  _handleModelKeyEnter(){
    //let _selectedModelId = this._form.controls.modelNumber.value.id;
    // let _checkModel = this._assetDataArray.find(x => x.id === _selectedModelId);
      
    //   if(_checkModel == undefined){
    //     
    //     .subscribe((data:IAssetDto) => {
    //       this.addSelectedItem(data);
    //     });
    // }
    // else {
    //   this._layoutComponent.openPopup({
    //     title: 'Validation',
    //     message: 'Asset is already added to the items',
    //     withoutConfirm: true
    //   });
    // }
  }
  _onDetailsRowSelectionChanges(e: any[]) {
    this._gridSelectedAssets = [...e];
  }
  _handleRemoveSelectedItem(item: IAssetDto){
    let val1 = this._assetDataArray.find(f => f.id === item.id);
    this._assetDataArray.splice(this._assetDataArray.indexOf(val1),1);
    this._assetDataArray = this._assetDataArray.filter((x: any) => x.rowindex != this._assetDataArray.indexOf(val1));

    let val = this.selectedItems.value.find((f: any) => f.id == item.id);
    this.selectedItems.value.splice(this.selectedItems.value.indexOf(val), 1);
    let ctrl = this.selectedItems.controls.find(g => g.value.id == item.id);
    this.selectedItems.controls.splice(this.selectedItems.controls.indexOf(ctrl), 1);
    this._assetDataArray = [];
    this._assetDataArray = this.selectedItems.value.map((f: { assetData: IAssetDto; }) => f.assetData);
    this._sharedService.onDeleteFromGrid.emit(true);
    /* remove from _gridSelectedAssets */
    let sVal = this._gridSelectedAssets.find(f => f === item.id);
    this._gridSelectedAssets.splice(this._gridSelectedAssets.indexOf(sVal),1);
    if(this._assetDataArray.length == 0){
      this._gridSelectedAssets = [];
      this.SelectedItemsGrid.ClearSelectedKeys();
    }
  }
  _onRemoveDetailsBatch(){
    if(this._gridSelectedAssets && this._gridSelectedAssets.length > 0){
      this._gridSelectedAssets.forEach((s:number) => {
        //let val = this._assetDataArray.find((f: any) => f.id == s);
        //this._handleRemoveSelectedItem(val);
        let val1 = this._assetDataArray.find(f => f.id === s);
        this._assetDataArray.splice(this._assetDataArray.indexOf(val1),1);
        this._assetDataArray = this._assetDataArray.filter((x: any) => x.rowindex != this._assetDataArray.indexOf(val1));

        let val = this.selectedItems.value.find((f: any) => f.id == s);
        this.selectedItems.value.splice(this.selectedItems.value.indexOf(val), 1);
        let ctrl = this.selectedItems.controls.find(g => g.value.id == s);
        this.selectedItems.controls.splice(this.selectedItems.controls.indexOf(ctrl), 1);
        this._assetDataArray = [];
        this._assetDataArray = this.selectedItems.value.map((f: { assetData: IAssetDto; }) => f.assetData);
        this._sharedService.onDeleteFromGrid.emit(true);
      });
      this._gridSelectedAssets = [];
      this.SelectedItemsGrid.ClearSelectedKeys();
    }
  }

  // #endregion
}
